<template>
  <v-menu
    offset-y
    right
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on">
        {{ name }}
        <v-icon>
          {{ icons.mdiChevronDown }}
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="handleNav('profile')">
        <v-icon class="mr-2">
          {{ icons.mdiAccountOutline }}
        </v-icon>
        {{ $t("Profile") }}
      </v-list-item>
      <v-list-item @click="handleLogout()">
        <v-icon class="mr-2">
          {{ icons.mdiLoginVariant }}
        </v-icon>
        {{ $t("Logout") }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiChevronDown,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiPageNextOutline,
  mdiLoginVariant,
} from "@mdi/js";

import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiChevronDown,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
        mdiPageNextOutline,
        mdiLoginVariant,
      },
    };
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async handleLogout() {
      try {
        await this.logout();
      } catch (error) {
        this.$dialog.notify.error(error.message);
      } finally {
        this.$router.push({ name: "auth-login" });
      }
    },
    handleNav(nav) {
      this.$router.push({ name: nav });
    },
    handleOuter() {
      window.open("https://admin.ridery.app/corporate_login", "_blank", "noopener,noreferrer");
    },
  },
  computed: {
    ...mapState("auth", ["name"]),
    initials() {
      if (this.name) {
        const fullName = this.name.split(" ");
        if (fullName.length === 2) {
          const initials =
            fullName.shift().charAt(0) + fullName.pop().charAt(0);
          return initials.toUpperCase();
        } else {
          const initials = this.name[0];
          return initials.toUpperCase();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active.user-profile-menu-content {
  z-index: 1000 !important;
}
</style>
